__webpack_require__.p = "/stipendium/stipac/sok/";